export const CURRENCY_VALUES_SYMBOLE = <const> [
	{ code: 'GBP', value: 'GBP - £' },
	{ code: 'SEK', value: 'SEK - öre' },
	{ code: 'USD', value: 'USD - $' },
	{ code: 'EUR', value: 'EUR - €' },
	{ code: 'CHF', value: 'CHF - franc' },
	{ code: 'RON', value: 'RON -  L' },
	{ code: 'YEN', value: 'YEN - ¥' }
];
